import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import kebabCase from 'lodash/kebabCase'
import { Flex, Box } from 'reflexbox/styled-components'
import styled from 'styled-components'

import media from 'media'

import ArrowLink from 'components/ArrowLink'

const arrowWidth = 30

const PaginationContainer = styled(Flex).attrs({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
})`
  position: relative;
  margin: 22px 0 0;

  ${media.tablet`
    width: 75%;
    margin: 22px auto;
  `}
`

const PaginationControls = styled(Box)`
  min-width: 100px;
`

const StyledArrowLink = styled(ArrowLink)`
  && {
    margin-top: 0;
  }
`

const Pagination = ({
  amountPosts,
  baseSlug,
  tag,
  pageNumber,
  pageAmount,
  currentEnd,
  scrollName,
  isStateful,
  handleChangeDisplayedPosts,
}) => {
  const [page, setPage] = useState(0)
  const [end, setEnd] = useState(0)

  useEffect(() => {
    setPage(pageNumber)
    setEnd(currentEnd)
  }, [currentEnd, pageNumber])

  const path = `/${baseSlug}${tag && tag !== 'All' ? `/${kebabCase(tag)}` : ''}`
  const totalPosts = amountPosts

  const ActionContainer = isStateful
    ? ({ to, ...others }) => <StyledArrowLink to={to} {...others} />
    : StyledArrowLink

  const prevLink = isStateful
    ? scrollName
    : `${path}${pageNumber - 1 === 0 ? '' : `/${pageNumber - 1}`}#${scrollName}`

  const nextLink = isStateful
    ? scrollName
    : `${path}/${pageNumber + 1}#${scrollName}`

  const handleStatefulPaginate = (e, action) => {
    if (isStateful) {
      e.preventDefault()
      setPage(page + action)
      handleChangeDisplayedPosts(page + action)
    }
  }

  return (
    <PaginationContainer>
      {page !== 0 ? (
        <ActionContainer
          to={prevLink}
          width={arrowWidth}
          direction="left"
          onClick={(e) => handleStatefulPaginate(e, -1)}
          data-cy="pagination-prev"
        >
          Previous
        </ActionContainer>
      ) : (
        <span style={{ width: '150px' }} />
      )}
      <PaginationControls data-cy="pagination-total">
        <strong>
          {page * pageAmount + 1} - {end}
        </strong>{' '}
        of {totalPosts}
      </PaginationControls>
      {end < totalPosts ? (
        <ActionContainer
          to={nextLink}
          width={arrowWidth}
          onClick={(e) => handleStatefulPaginate(e, 1)}
          data-cy="pagination-next"
        >
          Next
        </ActionContainer>
      ) : (
        <span style={{ width: '150px' }} />
      )}
    </PaginationContainer>
  )
}

export default Pagination

Pagination.propTypes = {
  amountPosts: PropTypes.number.isRequired,
  baseSlug: PropTypes.string.isRequired,
  tag: PropTypes.string,
  pageNumber: PropTypes.number.isRequired,
  pageAmount: PropTypes.number,
  currentEnd: PropTypes.number.isRequired,
  scrollName: PropTypes.string,
  isStateful: PropTypes.bool,
  handleChangeDisplayedPosts: PropTypes.func,
}
